import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

interface SpendBasedAmountDisplayProps {
  amount: string
  stampsToAdd: number
  amountPerStamp: number
  twoColumn: boolean
}

export function SpendBasedAmountDisplay({ amount, stampsToAdd, amountPerStamp, twoColumn }: SpendBasedAmountDisplayProps) {
  const { t } = useTranslation()
  const displayAmount = amount || '0'
  const stampsLabel = stampsToAdd === 1
    ? t('stampAwarding.stampCountSingle')
    : t('stampAwarding.stampCount', { count: stampsToAdd })

  if (twoColumn) {
    return (
      <View className="gap-3">
        <Text className="text-base font-semibold text-primary">
          {t('stampAwarding.spendBased.label')}
        </Text>

        <View className="rounded-lg bg-canvas-primary px-5 pt-4 pb-2 items-center justify-center">
          <View className="flex-row items-baseline gap-2">
            <Text className="text-6xl font-bold text-primary" numberOfLines={1}>{displayAmount}</Text>
            <Text className="text-lg text-secondary">{t('stampAwarding.spendBased.currencyLabel')}</Text>
          </View>
        </View>

        <Text className="text-sm text-secondary text-center">
          {t('stampAwarding.spendBased.earningRule', { amount: amountPerStamp })}
        </Text>

        <View className="rounded-lg bg-canvas-primary px-5 py-3 items-center justify-center gap-1">
          <Text className="text-sm text-secondary">{t('stampAwarding.thisWillAdd')}</Text>
          <Text className="text-3xl font-bold text-accent">{stampsLabel}</Text>
        </View>
      </View>
    )
  }

  return (
    <View className="gap-2">
      <View className="flex-row justify-between">
        <Text className="text-base font-semibold text-primary">
          {t('stampAwarding.spendBased.label')}
        </Text>
        <Text className="text-base font-semibold text-primary">
          {t('stampAwarding.thisWillAdd')}
        </Text>
      </View>
      <View className="flex-row items-baseline justify-between">
        <View className="flex-row items-baseline gap-2">
          <Text className="text-6xl font-bold text-primary" numberOfLines={1}>{displayAmount}</Text>
          <Text className="text-lg text-secondary">{t('stampAwarding.spendBased.currencyLabel')}</Text>
        </View>
        <Text className="text-4xl font-bold text-accent">{stampsLabel}</Text>
      </View>
    </View>
  )
}